const tr = {
  salePrice: "銷售價",
  maPrice: "物料總價",
  finallyPrice: "利潤",
  purePrice: "淨利潤",
  priceCheck: "成本核算",

  save: '保存',
  saveSuccess: '核算數據已更新',
  saveError: '核算數據更新失敗',
  saveTip: '確認保存',
  saveTipContent: '是否保存修改的優惠/折扣和佣金比例？',
  costUpdate: '成本核算數據有更改',
  costUpdateTip: '確定放弃更改麼？'
};

export default tr;